module.exports = __webpack_public_path__ + "img/107.7.3af553d0.png";